import { render, staticRenderFns } from "./PageEditor.vue?vue&type=template&id=d55fdf50&scoped=true"
import script from "./PageEditor.vue?vue&type=script&lang=js"
export * from "./PageEditor.vue?vue&type=script&lang=js"
import style0 from "./PageEditor.vue?vue&type=style&index=0&id=d55fdf50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55fdf50",
  null
  
)

export default component.exports